import { IParams } from '../params';

export const urbanParams: (keyof IParams)[] = [
  'publishPeriod',
  'isByHomeowner',
  'video',
  'withPhoto',
  'newbuildingCompletionYear',
  'developer',
  'rentTime',
  'roomsInDeal',
  'layout',
  'roomsTotal',
  'facilities',
  'area',
  'ceilingHeight',
  'floor',
  'floorsTotal',
  'houseMaterial',
  'demolishedInMoscowProgramm',
  'houseYear',
  'elevators',
  'balconies',
  'windows',
  'repair',
  'bathrooms',
  'decoration',
  'dwellingStatus',
  'tenants',
  'saleType',
  'parking',
  'undergroundTime',
  'rentTerms',
  'comission',
  'wordsInclude',
  'wordsExclude',
  'phone',
  'offerId',
];
